import { handleActions } from "redux-actions";

import {
    setCredentialsManagerDialog,
    mergeCredentialsManagerDialog,
    clearCredentials,
    getCredentials,
    getCredentialsSuccess,
    getCredentialsError,
    setSelectedCredentials
} from "./actions";

const initialState = {
    isLoading: false,
    count: 0,
    ids: [],
    credentials: {},
    selectedCredentials: [],
    createDialog: {
        initialData: null,
        isOpen: false,
        isLoading: false
    }
};

export const credentialsReducer = handleActions(
    {
        [clearCredentials]: () => ({ ...initialState }),

        [getCredentials]: (state) => ({
            ...state,
            credentials: [],
            selectedCredentials: [],
            count: 0,
            isLoading: true
        }),
        [getCredentialsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getCredentialsError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setSelectedCredentials]: (state, { payload }) => ({
            ...state,
            selectedCredentials: payload
        }),
        [setCredentialsManagerDialog]: (state, { payload }) => ({
            ...state,
            createDialog: {
                ...initialState.createDialog,
                ...payload
            }
        }),
        [mergeCredentialsManagerDialog]: (state, { payload }) => ({
            ...state,
            createDialog: {
                ...state.createDialog,
                ...payload
            }
        })
    },
    initialState
);
